import React from 'react';
import styles from './styles.css';
import {observer} from 'mobx-react';

function NotFound() {
  return (
    <div className={styles.notFound}>
      <h1>404 - Not Found</h1>
      <p>“These Are Not the Droids You Are Looking For”</p>
      <i className="material-icons">adb</i>
    </div>
  );
}

export default observer(NotFound);



// WEBPACK FOOTER //
// ./src/views/NotFound/NotFound.js